(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class VeloraMotion {
    constructor() {
      this.observer = null;
      this.init();
      document.addEventListener('shopify:section:load', () => {
        this.prepareScrollSections();
        this.observe();
      });
    }

    init() {
      document.documentElement.classList.add('velora-motion-ready');
      const loaderIsRunning = this.runLoader();
      this.runPageIntro(loaderIsRunning ? 620 : 80);
      this.prepareFooter();
      this.prepareScrollSections();
      this.observe();
    }

    prepareScrollSections() {
      const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
      if (!sections[0]?.querySelector('.velora-collection-groups-section')) {
        sections[0]?.querySelectorAll('[data-velora-reveal]').forEach((item) => {
          item.classList.add('is-revealed');
        });
      }
      sections.slice(1).forEach((section) => {
        section.setAttribute('data-velora-scroll-reveal', '');
      });
    }

    prepareFooter() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      document.querySelectorAll('.velora-footer details[open]').forEach((details) => details.removeAttribute('open'));
    }

    runLoader() {
      const loader = document.querySelector('[data-velora-loader]');
      const root = document.documentElement;
      if (!loader || reducedMotion.matches) {
        root.classList.remove('velora-loader-pending');
        return false;
      }
      try {
        if (sessionStorage.getItem('velora-loader-seen')) {
          root.classList.remove('velora-loader-pending');
          return false;
        }
        sessionStorage.setItem('velora-loader-seen', 'true');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the loader remains non-blocking.
      }
      loader.classList.add('is-active');
      root.classList.remove('velora-loader-pending');
      window.setTimeout(() => {
        loader.classList.add('is-leaving');
        window.setTimeout(() => loader.remove(), 320);
      }, 620);
      return true;
    }

    runPageIntro(delay) {
      const root = document.documentElement;
      const hasIntro =
        root.classList.contains('velora-mobile-intro') ||
        root.classList.contains('velora-desktop-intro');
      if (!hasIntro || reducedMotion.matches) {
        root.classList.remove('velora-mobile-intro');
        root.classList.remove('velora-desktop-intro');
        return;
      }
      window.setTimeout(() => {
        root.classList.add('velora-page-intro-complete');
        window.setTimeout(() => {
          root.classList.remove(
            'velora-mobile-intro',
            'velora-desktop-intro',
            'velora-page-intro-complete'
          );
        }, 1700);
      }, delay);
    }

    observe() {
      const items = [
        ...document.querySelectorAll(
          '[data-velora-reveal]:not(.is-revealed), [data-velora-scroll-reveal]:not(.is-revealed)'
        )
      ];
      if (!items.length) return;
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-revealed'));
        return;
      }
      if (!this.observer) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.observer.unobserve(entry.target);
          });
        }, {
          rootMargin: window.matchMedia('(max-width: 749px)').matches ? '0px 0px -3% 0px' : '0px 0px -8% 0px',
          threshold: window.matchMedia('(max-width: 749px)').matches ? 0.03 : 0.08
        });
      }
      items.forEach((item) => this.observer.observe(item));
    }
  }

  const start = () => new VeloraMotion();
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();

})();
